<div class="py-3 lg:py-1">
  <!-- Header with title and toggle button -->
  <div class="flex items-center justify-between cursor-pointer" (click)="toggleCollapsed()">
    <div class="flex items-center text-[1.2em] lg:text-base font-semibold mb-2 lg:mb-1">
      {{ title() }}
      @if (activeFilterCount() > 0) {
      <div class="text-xs lg:text-sm font-bold bg-warning theme-border shadow-sm rounded-full px-2 py-px ml-2">
        {{ activeFilterCount() }}
      </div>
      }

    </div>
    <app-icon-button [icon]="collapsed() ? 'add-outline' : 'chevron-up-outline'" color="purple" [border]="true" [shadow]="true" size="sm" (click)="toggleCollapsed(); $event.stopPropagation()"></app-icon-button>
  </div>

  <!-- Collapsible content area -->
  <div [@expandCollapse]="collapsed() ? 'collapsed' : 'expanded'">
    <div class="pt-2">
      <ng-content></ng-content>
    </div>
    @if (activeFilterCount() > 0) {
    <div class="mt-6">
      <app-chip [clickable]="true" [outline]="true" [shadow]="false" (click)="onClearFilters.emit()"
        [color]="'danger'">
        Clear all</app-chip>
    </div>
    }
  </div>
</div>